import React, { Component, createRef } from "react";
import Dropzone from "react-dropzone";

import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import { Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

class MacOperatorUserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);
    this.state = { selectedFiles: [] };
  }

  handleAcceptedFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size),
      })
    );

    this.setState({ selectedFiles: files });
  };

  handleSubmit(e) {
    e.preventDefault();

    const modifiedV = { ...this.state.validation };

    this.setState({ validation: modifiedV });
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  render() {
    //meta title
    document.title = "machine operator flow";
    const { validation } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("My Profile")} />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <div className="d-flex flex-row mb-4 justify-content-between">
                      <div>
                        <h4 className="text-black fw-bold mb-4">My Profile</h4>
                      </div>
                      <div>
                        <div className="d-inline-block me-3 fs-5 fw-bold">
                          Active
                        </div>
                        <div className="form-check form-switch d-inline-block">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="site_state"
                            checked
                          />
                          <label
                            htmlFor="site_state"
                            className="form-check-label pt-4"
                          ></label>
                        </div>
                      </div>
                    </div>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        userName: (this.state && this.state.userName) || "",
                        userRole: (this.state && this.state.userRole) || "",
                        employeecode:
                          (this.state && this.state.employeecode) || "",
                        factoryname:
                          (this.state && this.state.factoryname) || "",
                        timeshift: (this.state && this.state.timeshift) || "",
                        gender: (this.state && this.state.gender) || "",
                        mobile1: (this.state && this.state.mobile1) || "",
                        mobile2: (this.state && this.state.mobile2) || "",
                        email: (this.state && this.state.email) || "",
                        newpassword:
                          (this.state && this.state.newpassword) || "",
                        confirmpassword:
                          (this.state && this.state.confirmpassword) || "",
                        address1: (this.state && this.state.address1) || "",
                        address2: (this.state && this.state.address2) || "",
                        city: (this.state && this.state.city) || "",
                        state: (this.state && this.state.state) || "",
                        notes: (this.state && this.state.notes) || "",
                      }}
                      validationSchema={Yup.object().shape({
                        attachment: Yup.mixed()
                          .nullable()
                          .notRequired()
                          .test(
                            "FILE_SIZE",
                            "Uploaded file is too big.",
                            value =>
                              !value || (value && value.size <= FILE_SIZE)
                          )
                          .test(
                            "FILE_FORMAT",
                            "Uploaded file has unsupported format.",
                            value =>
                              !value ||
                              (value && SUPPORTED_FORMATS.includes(value.type))
                          ),
                        userName: Yup.string().required(
                          "Please Enter Your Name"
                        ),
                        userRole: Yup.string().required(
                          "Please Select User Role"
                        ),
                        employeecode: Yup.string().required(
                          "Please Enter Your Code"
                        ),
                        factoryname: Yup.string().required(
                          "Please Enter Your Factory name"
                        ),
                        timeshift: Yup.string().required(
                          "Please Enter Your Time"
                        ),
                        gender: Yup.string().required(
                          "Please Select Your Gender"
                        ),
                        mobile1: Yup.string().required(
                          "Please Enter Your Mobile Number"
                        ),
                        mobile2: Yup.string().required(
                          "Please Enter Your Mobile Number"
                        ),
                        email: Yup.string().required("Please Enter Your email"),
                        newpassword: Yup.string()
                          .required("Password is required")
                          .min(5, "Your password is too short.")
                          .matches(
                            "(?=.*[!@#$%^&*])",
                            "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
                          ),
                        confirmpassword: Yup.string()
                          .required()
                          .oneOf(
                            [Yup.ref("newpassword"), null],
                            "Passwords must match"
                          ),
                        address1: Yup.string().required(
                          "Please Enter Your Address"
                        ),
                        address2: Yup.string().required(
                          "Please Enter Your Address"
                        ),
                        city: Yup.string().required("Please Enter Your city"),
                        state: Yup.string().required("Please Enter Your state"),
                        notes: Yup.string().required("Please Enter Your notes"),
                      })}
                      onSubmit={values => {}}
                    >
                      {({ errors, status, touched, values }) => (
                        <Form className="needs-validation">
                          <Row>
                            <div className="mb-3 row">
                              <label
                                htmlFor="example-number-input"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("User Photo")}
                                </h5>
                              </label>
                              <div className="col-md-10">
                                <Dropzone
                                  onDrop={acceptedFiles =>
                                    this.handleAcceptedFiles(acceptedFiles)
                                  }
                                >
                                  {({ getRootProps, getInputProps }) => (
                                    <div className="dropzone">
                                      <div
                                        className="dz-message needsclick"
                                        {...getRootProps()}
                                      >
                                        <input {...getInputProps()} />
                                        <div className="mb-3">
                                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                                        </div>
                                        <h4>
                                          Drop logo here or click to upload.
                                        </h4>
                                      </div>
                                    </div>
                                  )}
                                </Dropzone>
                                <div
                                  className="dropzone-previews mt-3"
                                  id="file-previews"
                                >
                                  {this.state.selectedFiles.map((f, i) => {
                                    return (
                                      <Card
                                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                        key={i + "-file"}
                                      >
                                        <div className="p-2">
                                          <Row className="align-items-center">
                                            <Col className="col-auto">
                                              <img
                                                data-dz-thumbnail=""
                                                height="80"
                                                className="avatar-sm rounded bg-light"
                                                alt={f.name}
                                                src={f.preview}
                                              />
                                            </Col>
                                            <Col>
                                              <Link
                                                to="#"
                                                className="text-muted font-weight-bold"
                                              >
                                                {f.name}
                                              </Link>
                                              <p className="mb-0">
                                                <strong>
                                                  {f.formattedSize}
                                                </strong>
                                              </p>
                                            </Col>
                                          </Row>
                                        </div>
                                      </Card>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="userName"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("User Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.userName && touched.userName
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="userName"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="userName"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="userRole"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("User Role")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.userRole && touched.userRole
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="userRole"
                                  as="select"
                                >
                                  <option disabled value="">
                                    select user Role
                                  </option>
                                  <option value="dataentry">Data Entry</option>
                                  <option value="grader"> Grader </option>
                                  <option value="filler">Filler</option>
                                  <option value="machineoprator">
                                    Machine Operator
                                  </option>
                                  <option value="boilman">Boil Man</option>
                                </Field>
                                <ErrorMessage
                                  name="userRole"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="employeecode"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Employee Code')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.employeecode && touched.employeecode
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="employeecode"
                                  placeholder="ADM00001"
                                />
                                <ErrorMessage
                                  name="employeecode"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="factoryname"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Factory(Unit) Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.factoryname && touched.factoryname
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="factoryname"
                                  as="select"
                                >
                                  <option disabled value="">
                                    select factory Name
                                  </option>
                                  <option value="xyzParty">
                                    XYZ Diamond
                                  </option>
                                  <option value="xyzParty">
                                    XYZ Diamond
                                  </option>
                                  <option value="xyzParty">
                                    XYZ Diamond
                                  </option>
                                  <option value="xyzParty">
                                    XYZ Diamond
                                  </option>
                                </Field>
                                <ErrorMessage
                                  name="factoryname"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="timeshift"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("User Time Shift")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.timeshift && touched.timeshift
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="timeshift"
                                  as="select"
                                >
                                  <option disabled value="">
                                    select factory Name
                                  </option>
                                  <option value="xyzParty">
                                    Shift-1 (7:00 AM To 3:00 PM)
                                  </option>
                                  <option value="xyzParty">
                                    Shift-2 (7:00 AM To 3:00 PM)
                                  </option>
                                  <option value="xyzParty">
                                    Shift-3 (7:00 AM To 3:00 PM)
                                  </option>
                                </Field>
                                <ErrorMessage
                                  name="timeshift"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="mobile1"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Mobile no.1')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.mobile1 && touched.mobile1
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number" onWheel={(e) => e.target.blur()}
                                  name="mobile1"
                                  placeholder="+91 (132)(564)(9872)"
                                />
                                <ErrorMessage
                                  name="mobile1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="mobile2"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Mobile no.2')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.mobile2 && touched.mobile2
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number" onWheel={(e) => e.target.blur()}
                                  name="mobile2"
                                  placeholder="+91 (132)(564)(9872)"
                                />
                                <ErrorMessage
                                  name="mobile2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="email"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Email ID')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.email && touched.email
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="email"
                                  name="email"
                                  placeholder="xyzdiamond123@gmail.com"
                                />
                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="newpassword"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("New Password")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.newpassword && touched.newpassword
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="password"
                                  name="newpassword"
                                  placeholder="************"
                                />
                                <ErrorMessage
                                  name="newpassword"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="confirmpassword"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Confirm Password")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.confirmpassword &&
                                    touched.confirmpassword
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="password"
                                  name="confirmpassword"
                                  placeholder="************"
                                />
                                <ErrorMessage
                                  name="confirmpassword"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="address1"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Address line 1')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.address1 && touched.address1
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="address1"
                                  placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                />
                                <ErrorMessage
                                  name="address1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="address2"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Address line 2')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.address2 && touched.address2
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="address2"
                                  placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                />
                                <ErrorMessage
                                  name="address2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="city"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('City')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.city && touched.city
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="city"
                                  placeholder="Enter Your city"
                                />
                                <ErrorMessage
                                  name="city"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="state"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('State')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.state && touched.state
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="state"
                                  as="select"
                                >
                                  <option value="" disabled>select</option>
                                  <option value="Gujarat">Gujarat</option>
                                  <option value="Maharashtra">
                                    Maharashtra
                                  </option>
                                  <option value="Tamil Nadu">Tamil Nadu</option>
                                  <option value="Uttar Pradesh">
                                    Uttar Pradesh
                                  </option>
                                  <option value="West Bengal">
                                    West Bengal
                                  </option>
                                  <option value="Karnataka">Karnataka</option>
                                  <option value="Rajasthan">Rajasthan</option>
                                  <option value="Andhra Pradesh">
                                    Andhra Pradesh
                                  </option>
                                  <option value="Madhya Pradesh">
                                    Madhya Pradesh
                                  </option>
                                </Field>
                                <ErrorMessage
                                  name="state"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="note"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {" "}
                                  User Notes
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.notes && touched.notes
                                      ? " is-invalid"
                                      : "")
                                  }
                                  as="textarea"
                                  name="notes"
                                  rows="7"
                                ></Field>

                                <ErrorMessage
                                  name="notes"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="col-md-12 text-end">
                              <Button
                                color="primary"
                                className="fs-4 px-5"
                                type="submit"
                              >
                                Submit
                              </Button>
                            </div>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default MacOperatorUserProfile;
